<template>
    <div class="template-base">
        <ReserveDialog v-if="showReservationDialog" @on-cancel="toggleReservationDialog" @on-submit="submitReservation" :selectedSlotX="selectedSlot" />

        <Header Title="Player Schedule" class="div-header" :isProcessing="fetchData" :errorMessage="errorMessage" :noSignOut="true" />

        <div style="display:flex">
            <div>
                <Calendar @on-day-selected="onDaySelected" />
            </div>

            <div style="display:flex;flex-wrap:wrap">
                <div v-show="noSlots" style="font-size:18pt; margin:50px">No availability for this day</div>
                <ResourceItem v-for="slot in availableSlots" :key="slot.instanceId" :resource="slot" @on-selected="onSelected" />
            </div>
        </div>
    </div>
</template>

<script>
import Header from "../../components/Shared/Header";
import apiScheduler from "../../api/apiScheduler";
import globalStatus from "../../composables/globalStatus";
import { ref } from "@vue/reactivity";
import ReserveDialog from "../../components/Scheduler/ReserveDialog";
import ResourceItem from "../../components/Scheduler/ResourceItem";
import Calendar from "../../components/Shared/Calendar";

export default {
    components: { Header, ReserveDialog, ResourceItem, Calendar },

    setup() {
        const showReservationDialog = ref(false);
        const selectedSlot = ref();
        const availableSlots = ref([]);
        const selectedDay = ref(new Date());
        const noSlots = ref(false)

        const toggleReservationDialog = () => {
            showReservationDialog.value = !showReservationDialog.value;
        };

        const { fetchData, errorMessage, resetStatus } = globalStatus();

        const onError = (err) => {
            console.error(err);
            errorMessage.value = err;
        };

        const submitReservation = async () => {
            toggleReservationDialog();
            getData();
        };

        const getData = async () => {
            try {
                resetStatus("Loading...");
                var availableSlotsResponse = await apiScheduler.getAvailableSlots(selectedDay.value, "bays");

                availableSlots.value = availableSlotsResponse.availableSlots.filter((x) => new Date(x.slotEnd) > new Date());                

                availableSlots.value.sort((a, b) => {
                    const A = a.slotStart + a.scheduleResourceName;
                    const B = b.slotStart + b.scheduleResourceName;

                    let comparison = 0;
                    if (A > B) {
                        comparison = 1;
                    } else if (A < B) {
                        comparison = -1;
                    }
                    return comparison;
                });

                noSlots.value = availableSlots.value.length === 0                
            } catch (err) {
                console.error(err);
                errorMessage.value = "Error fetching data";
            }            
            fetchData.value = false;
        };

        const onSelected = (slot) => {            
            selectedSlot.value = slot;
            toggleReservationDialog();
        };

        const onDaySelected = (day) => {
            selectedDay.value = day;
            getData();
        };

        getData(new Date());

        return {
            fetchData,
            errorMessage,
            onError,
            toggleReservationDialog,
            showReservationDialog,
            selectedSlot,
            submitReservation,

            availableSlots,
            onSelected,
            onDaySelected,
            noSlots
        };
    }
};
</script>

<style></style>
